<script setup>
import { ref, computed, onBeforeUnmount, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useGroupsAttrsStore } from '@/stores/groups-attrs'
import { useCarUsersStore } from '@/stores/car-users'
import userName from '@/helpers/userName'

function changePage(cursor, dir) {

    const params = {
        'c.limit': 6, 
        'c.direction': dir, 
        'c.cursor': cursor
    }

    carUsersStore.readCarUsersCreateList(params).then(result => {
        if(result.array) {
            dir == 'after' ? 
                pageNumber.value++ : 
                pageNumber.value--
        }
    })
}

function submitForm(event) {

    const fields = event.target.getElementsByTagName("input")

    let data = {

        attr: {

            array: []
        },
        car: fields.car.value,
        user: fields.user.value
    }

    for(let field of fields) {

        if(field.type == 'checkbox' && field.checked) {

            if(field.name == 'navi')        data.attr.array.push(...attrsNavi.value)
            if(field.name == 'remote')      data.attr.array.push(...attrsRemote.value)
            if(field.name == 'diagnostic')  data.attr.array.push(...attrsDiagnostic.value)
            if(field.name == 'developer')   data.attr.array.push(...attrsDeveloper.value)
        }
    }

    carUsersStore.createCarUsers(data)
}

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const translaterStore   = useTranslaterStore()
const groupsAttrsStore  = useGroupsAttrsStore()
const carUsersStore     = useCarUsersStore()

const getTranslate              = computed(() => translaterStore.getTranslate)
const attrsNavi                 = computed(() => groupsAttrsStore.navi)
const attrsRemote               = computed(() => groupsAttrsStore.remote)
const attrsDiagnostic           = computed(() => groupsAttrsStore.diagnostic)
const attrsDeveloper            = computed(() => groupsAttrsStore.developer)
const carUsersCreateList        = computed(() => carUsersStore.carUsersCreateList)
const carUsersCreateListMsg     = computed(() => carUsersStore.carUsersCreateListMsg)
const carUsersCreateListProcess = computed(() => carUsersStore.carUsersCreateListProcess)
const carUsersCreateMsg         = computed(() => carUsersStore.carUsersCreateMsg)

const pageNumber = ref(1)
const showAttrs = ref([])
const inputSearch = ref('')

carUsersStore.readCarUsersCreateList({ 'c.limit': 6 })

onBeforeUnmount(() => {

    carUsersStore.setCarUsersCreateMsg({})
})

watch(inputSearch, input => {

    input.length > 2 ? 
        carUsersStore.readCarUsersCreateList({ 'c.limit': 6, 'c.q': input }) :
        carUsersStore.readCarUsersCreateList({ 'c.limit': 6 })
})
</script>

<template>
    <div class="uta-car-users-create">

        <div class="row mb-4 justify-content-between">
            <div class="col-12">
                <div class="uta-input__wrapper uta-search">
                    <input 
                        type="text" 
                        :placeholder="getTranslate.SEARCH + '...'" 
                        v-model="inputSearch"
                        @keyup.escape="inputSearch = ''"
                        class="form-control uta-input__wrapper-input uta-search__input uta-search__input--light" 
                    >
                    <template v-if="inputSearch.length > 2">
                        <span class="material-icons uta-input__wrapper-icon" @click="inputSearch = ''">
                            cancel
                        </span>
                    </template>
                    <template v-else>
                        <span class="material-icons uta-input__wrapper-icon">
                            search
                        </span>
                    </template>
                </div>
            </div>
        </div>

        <div 
            v-if="'success' in carUsersCreateListMsg && !carUsersCreateListMsg.success"
            class="my-4 uta-alert uta-alert--danger" 
        >
            <span class="material-icons uta-alert__icon">check_circle_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[carUsersCreateListMsg.text] || carUsersCreateListMsg.text }}
            </div>
        </div>

        <div 
            v-if="'success' in carUsersCreateMsg"
            class="my-4 uta-alert" 
            :class="{
                'uta-alert--success' : carUsersCreateMsg.success, 
                'uta-alert--danger' : !carUsersCreateMsg.success
            }"
        >
            <span class="material-icons uta-alert__icon">check_circle_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[carUsersCreateMsg.text] || carUsersCreateMsg.text }}
            </div>
            <button type="button" class="uta-alert__close" @click="carUsersStore.setCarUsersCreateMsg({})">
                <span class="material-icons">close</span>
            </button>
        </div>

        <template v-if="carUsersCreateList.array?.length">
            <div class="mb-4 uta-list uta-car-users-create__list">
                <form
                    v-for="(user, index) in carUsersCreateList.array"
                    :key="index"
                    class="row uta-list__item uta-car-users-create__item"
                    @submit.prevent="submitForm($event)" 
                >
                    <div class="col-10 uta-car-users-create__name" @click="showAttrs[index] = !showAttrs[index]">
                        <span href="#" class="uta-list__item-link uta-car-users-create__name">
                            {{ userName(user) || getTranslate.USERS_NEW_USER }}
                        </span>
                    </div>

                    <div class="col-2 text-end uta-car-users-create__attrs-ctrl" @click="showAttrs[index] = !showAttrs[index]">
                        <span class="material-icons">
                            expand_more
                        </span>
                    </div>

                    <div class="col-12 pt-3 uta-car-users-create__attrs" v-show="showAttrs[index]">

                        <!-- Навигационная информация -->
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                name="navi"
                                class="form-check-input __attrs-attr" 
                                :id="'users-group-cars-attr_navi-' + user.uuid"
                            > 
                            <label 
                                class="form-check-label" 
                                :for="'users-group-cars-attr_navi-' + user.uuid"
                            >
                                {{ getTranslate.ATTR_GEODATA }}
                            </label>
                        </div>

                        <!-- Удаленное управление -->
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                name="remote"
                                class="form-check-input uta-car-users-create__attrs-attr" 
                                :id="'users-group-cars-attr_remote-' + user.uuid"
                            > 
                            <label 
                                class="form-check-label" 
                                :for="'users-group-cars-attr_remote-' + user.uuid"
                            >
                                {{ getTranslate.ATTR_REMOTE_CONTROL }}
                            </label>
                        </div>

                        <!-- Диагностика -->
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                name="diagnostic"
                                class="form-check-input uta-car-users-create__attrs-attr" 
                                :id="'users-group-cars-attr_diagnostic-' + user.uuid"
                            > 
                            <label 
                                class="form-check-label" 
                                :for="'users-group-cars-attr_diagnostic-' + user.uuid"
                            >
                                {{ getTranslate.ATTR_DIAGNOSTIC }}
                            </label>
                        </div>

                        <!-- Режим разработчика -->
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                name="developer"
                                class="form-check-input uta-car-users-create__attrs-attr" 
                                :id="'users-group-cars-attr_developer-' + user.uuid"
                            > 
                            <label 
                                class="form-check-label" 
                                :for="'users-group-cars-attr_developer-' + user.uuid"
                            >
                                {{ getTranslate.ATTRS_DEVELOPER }}
                            </label>
                        </div>

                        <input type="hidden" name="user" :value="user.uuid">
                        <input type="hidden" name="car" :value="props.uuid">

                        <button type="submit" class="uta-btn uta-btn--main mt-3">{{ getTranslate.BTN_ADD }}</button>
                    </div>
                </form>
            </div>

            <div class="uta-cars__pagination" v-if="carUsersCreateList.c && (carUsersCreateList.c.isBefore || carUsersCreateList.c.isAfter)">
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="uta-pagination">
                            <button 
                                :disabled="carUsersCreateListProcess || !carUsersCreateList.c.isBefore"
                                class="uta-btn uta-btn--sm uta-pagination__prev" 
                                @click.prevent="changePage(carUsersCreateList.c.start, 'before')"
                            >
                                <span class="material-icons">
                                    navigate_before
                                </span>
                            </button>
                            <div class="uta-pagination__current">
                                {{ pageNumber }}
                            </div>
                            <button 
                                :disabled="carUsersCreateListProcess || !carUsersCreateList.c.isAfter"
                                class="uta-btn uta-btn--sm uta-pagination__next" 
                                @click.prevent="changePage(carUsersCreateList.c.stop, 'after')"
                            >
                                <span class="material-icons">
                                    navigate_next
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </template>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/car-users-create.scss';
</style>